import { render, staticRenderFns } from "./CollegeDetails.vue?vue&type=template&id=3d15b3b6&scoped=true&"
import script from "./CollegeDetails.vue?vue&type=script&lang=js&"
export * from "./CollegeDetails.vue?vue&type=script&lang=js&"
import style0 from "./CollegeDetails.vue?vue&type=style&index=0&id=3d15b3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d15b3b6",
  null
  
)

export default component.exports